import * as React from "react";

import { cn } from "../../../utils";
import { cva, VariantProps } from "class-variance-authority";

export type TInputProps = React.InputHTMLAttributes<HTMLInputElement> &
  VariantProps<typeof inputVariants>;
const inputVariants = cva("input-default", {
  variants: {
    variant: {
      default: "input-md",
      sm: "input-sm",
      lg: "input-lg",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const Input = React.forwardRef<HTMLInputElement, TInputProps>(
  ({ className, type, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn("flex", inputVariants({ variant }), className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
